import React, { useState } from "react"
import { Card, CardContent, Grid } from "@mui/material"
import CloseIcon from '@mui/icons-material/Close'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { BLACK, PRIMARY, WHITE } from "../ui/Colors"
import { PrimaryText, SecondaryText, } from "../ui/Text"

interface OwnProps {
    children: any;
    title?: string;
    subtitle?: string;
    flex: any;
    help?: string | JSX.Element
}

interface HelpProps {
    children: string | JSX.Element
}

const CloseBtn = ({ setHelp }: { setHelp: React.Dispatch<React.SetStateAction<boolean>> }) => {
    return (
        <Grid
            container
            justifyContent="center"
            alignItems="center"
            onClick={(e) => {
                e.stopPropagation();
                setHelp(false)
            }}
            sx={{
                borderRadius: "45px",
                background: "white",
                width: "1.5vw",
                height: "1.5vw",
                position: "absolute",
                right: '0.5vw',
                top: '1vh'
            }}
        >
            <CloseIcon
                sx={{
                    cursor: 'pointer',
                    width: '2vw',
                    height: '2vh',
                }}
            />
        </Grid>
    )
}

const Help = ({ children }: HelpProps) => {
    const [isHelp, setHelp] = useState(false)

    const position = {
        right: "1vw",
        top: "1.2vh"
    }

    return (
        <Grid
            container
            onClick={() => { setHelp(true) }}
            sx={{
                cursor: "pointer",
                position: "absolute",
                right: position.right,
                top: position.top,
                height: "20px",
                width: "20px",
                zIndex: "99999",
                transition: "all 0.3s ease-out",
                ...(isHelp ? {
                    right: 0,
                    top: 0,
                    width: "100%",
                    height: "100% !important"
                } : null)
            }}>
            {!isHelp && <HelpOutlineIcon />}
            {isHelp && <Grid container sx={{
                position: "relative",
                background: PRIMARY,
                justifyContent: "center",
                alignItems: "center"
            }}>
                {typeof children === "string" ? <PrimaryText color={WHITE}>{children}</PrimaryText> : children}
                <CloseBtn setHelp={setHelp} />
            </Grid>}
        </Grid >
    )
}

export const BasicCard = ({ children, title, subtitle, flex, help }: OwnProps) => {
    const [isHover, setHover] = useState<boolean>(false)

    return (
        <Card
            sx={{
                padding: '0.5vw',
                flex: flex,
                flexWrap: "wrap",
                mb: "1.5vh",
                mr: "0.2vw",
                ml: "0.2vw",
                position: "relative"
            }}
            onMouseOver={() => {
                setHover(true)
            }}
            onMouseLeave={() => {
                setHover(false)
            }}
        >
            {isHover && help && <Help>{help}</Help>}
            <CardContent
                sx={{
                    padding: '0px',
                    ':last-child': { padding: '0px' },
                    display: 'flex',
                    alignItems: 'center',

                }}
            >
                <Grid width="100%">
                    {(title || subtitle) && <Grid container direction="column" mb="3vh">
                        {title && <PrimaryText bold color={BLACK} gutterBottom mb="1vh">
                            {title}
                        </PrimaryText>}
                        {subtitle && <SecondaryText>{subtitle}</SecondaryText>}
                    </Grid>}
                    <Grid>
                        {children}
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}